export default "__VITE_ASSET__e62bd542__"